var _excluded = ["onBlur", "value", "onFocus", "onChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import s from './input.scss';
import cx from 'classnames';
import { StatusAlert } from 'wix-ui-icons-common';

var Input = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Input, _Component);

  function Input(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "inputCreated", function (el) {
      _this.inputElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "onInputBlur", function () {
      _this.setState({
        state: '',
        showIndicator: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputFocus", function () {
      var onFocus = _this.props.onFocus;

      _this.setState({
        state: s.focus,
        showIndicator: true
      });

      if (onFocus) {
        onFocus();
      }
    });

    _this.state = {
      state: ''
    };
    return _this;
  }

  var _proto = Input.prototype;

  _proto.focus = function focus() {
    if (this.inputElement) {
      this.inputElement.focus();
    }
  };

  _proto.render = function render() {
    var _cx,
        _cx2,
        _this2 = this,
        _cx3;

    var _this$props = this.props,
        text = _this$props.text,
        placeholder = _this$props.placeholder,
        onChange = _this$props.onChange,
        limit = _this$props.limit,
        style = _this$props.style,
        _this$props$inputProp = _this$props.inputProps,
        inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp,
        showErrors = _this$props.showErrors,
        errorMessage = _this$props.errorMessage,
        id = _this$props.id,
        dataAid = _this$props.dataAid,
        forceHideIndicator = _this$props.forceHideIndicator,
        bng = _this$props.bng,
        _this$props$errorStyl = _this$props.errorStyle,
        errorStyle = _this$props$errorStyl === void 0 ? Input.ErrorStyleBottomText : _this$props$errorStyl;
    var state = this.state.state;
    var showIndicator = this.state.showIndicator;

    if (forceHideIndicator) {
      showIndicator = false;
    }

    var errorTheme = null;
    var errorComponent = null;

    if (showErrors) {
      switch (errorStyle) {
        case Input.ErrorStyleBottomText:
          errorTheme = s.error;
          errorComponent = /*#__PURE__*/React.createElement("span", {
            className: s.errorMessage
          }, errorMessage);
          break;

        case Input.ErrorStyleIcon:
          errorTheme = s.errorWithIcon;
          errorComponent = /*#__PURE__*/React.createElement(StatusAlert, {
            className: s.errorIcon
          });
          break;

        default:
          break;
      }
    }

    var classes = cx(s.container, state, s[style], (_cx = {}, _cx[errorTheme] = showErrors, _cx), (_cx2 = {}, _cx2[s.bng] = bng, _cx2));
    var onBlurFunc = this.onInputBlur;
    var onFocusFunc = this.onInputFocus;
    var onChangeFunc = onChange;

    if (inputProps && inputProps.onBlur) {
      onBlurFunc = function onBlurFunc(e) {
        _this2.onInputBlur(e);

        inputProps.onBlur(e);
      };
    }

    if (inputProps && inputProps.onFocus) {
      onFocusFunc = function onFocusFunc(e) {
        _this2.onInputFocus(e);

        inputProps.onFocus(e);
      };
    }

    if (inputProps && inputProps.onChange) {
      onChangeFunc = function onChangeFunc(e) {
        onChange(e);
        inputProps.onChange(e);
      };
    }

    var onBlur = inputProps.onBlur,
        value = inputProps.value,
        onFocus = inputProps.onFocus,
        onChange2 = inputProps.onChange,
        finalInputProps = _objectWithoutPropertiesLoose(inputProps, _excluded); //eslint-disable-line


    var limitText = text ? limit - text.length : '';
    var inputPosition = showErrors && errorStyle === 'icon' ? 'relative' : 'static';
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        position: inputPosition
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes
    }, /*#__PURE__*/React.createElement("input", _extends({
      type: "text",
      autoComplete: "off",
      "data-aid": dataAid,
      ref: this.inputCreated,
      id: id,
      placeholder: placeholder || '',
      maxLength: limit
    }, finalInputProps, {
      onBlur: onBlurFunc,
      onFocus: onFocusFunc,
      onChange: onChangeFunc,
      value: text,
      className: cx(s.madeForFont)
    })), /*#__PURE__*/React.createElement("div", {
      className: cx(s.indicator, (_cx3 = {}, _cx3[s.indicatorVisible] = showIndicator && limit, _cx3)),
      style: {
        display: 'flex',
        flexDirection: 'column'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        marginTop: 'auto'
      }
    }, limitText))), showErrors && errorComponent);
  };

  return Input;
}(Component);

_defineProperty(Input, "ErrorStyleIcon", 'icon');

_defineProperty(Input, "ErrorStyleBottomText", 'underline');

Input.defaultProps = {
  forceHideIndicator: true
};
export default Input;